import React, { useEffect } from 'react'
import { Grid, } from '@material-ui/core';
import Controls from "../../../controls/Controls";
import { useForm, Form } from '../../../controls/useForm';
import { request } from '../../../../api/Service'
import { store } from '../../../../redux-store/store';


const initialFValues = {
    locationId: 0,
    sku: "",
    count: 0,
    productDescription: "",
    remark: "",

}

export default function AddInventoryCount(props) {
    const { addOrEdit,addInventory ,recordForEdit, products, locations ,setOpenPopup} = props
    const validate = (fieldValues = values) => {
        let temp = { ...errors }
        if ('remark' in fieldValues)
            temp.remark = fieldValues.remark  ? "" : "This field is required."
        if ('productDescription' in fieldValues)
            temp.productDescription = fieldValues.productDescription ? "" : "This field is required."
        if ('count' in fieldValues)
            temp.count = fieldValues.count !==0? "" : "This field is required."
        if ('sku' in fieldValues)
            temp.sku = fieldValues.sku ? "" : "This field is required."
        if ('locationId' in fieldValues)
            temp.locationId = fieldValues.locationId >0 ? "" : "Select a Location Type"
        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x === "")
    }

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    } = useForm(initialFValues, true, validate);

    const handleSubmit = e => {
        e.preventDefault()
        if (validate()) {
            store.dispatch({ type: "DISPLAY_LOADER" })
            request('post', values, `inventory-count`).then(data => {
                store.dispatch({ type: "DISPLAY_LOADER" })
                store.dispatch({ type: "LOAD_INVENTORY_COUNT",payload:{} })
                
                setOpenPopup(false)
            }
    
            )
        }

    }


    return (
        <Form onSubmit={handleSubmit}>
            <Grid container>
            <Grid item xs={6}>
                    <Controls.Input
                        name="count"
                        label="Count"
                        value={values.count || ''}
                        onChange={handleInputChange}
                        error={errors.count}
                    />
                    <Controls.Input
                        name="remark"
                        label="Remark"
                        value={values.remark || ''}
                        onChange={handleInputChange}
                        error={errors.remark}
                    />
                    <Controls.Input
                        label="Product Description"
                        name="productDescription"
                        value={values.productDescription || ''}
                        onChange={handleInputChange}
                        error={errors.productDescription}
                    />
                  

                </Grid>
                <Grid item xs={6}>
                    <Controls.Select
                        name="locationId"
                        label="Location"
                        value={values.locationId || ''}
                        onChange={handleInputChange}
                        options={locations}
                        error={errors.locationId}
                    />
                    <div style={{ position: 'relative' }}>
                        <Controls.Input
                            label="SKU"
                            name="sku"
                            value={values.sku || ''}
                            onChange={handleInputChange}
                            error={errors.sku}

                        /> <i style={{ position: 'absolute', bottom: '20%', left: '68%' }} className="fas fa-barcode fa-3x"></i>

                    </div>
                    <div>
                        <Controls.Button
                            type="submit"
                            text="Submit" />
                    </div>
                </Grid>
            </Grid>
        </Form>
    )
}
